import React from 'react';
import { Card, CardContent, CardMedia, Typography, Grid, Box, Container } from '@mui/material';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import appImage from '../assests/blog2.jpeg';
import webImage from '../assests/blog1.jpeg';
import logoImage from '../assests/blog3.jpeg';

const blogData = [
  { id: 1, title: 'title1', description: 'description1', image: appImage },
  { id: 2, title: 'title2', description: 'description2', image: webImage },
  { id: 3, title: 'title3', description: 'description3', image: logoImage },
];

const slugify = (title) => title.split(' ').slice(0, 4).join(' ')
  .toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
  .replace(/[^a-z0-9 ]/g, '').replace(/\s+/g, '-');

export default function Blogs() {
  const { t, i18n } = useTranslation();
  const isEnglish = i18n.language?.startsWith('en');
  const title = isEnglish ? 'Insights & inspiration' : 'Kunskap & inspiration';

  return (
    <Box component="main" sx={{ py: { xs: 5, md: 8 }, backgroundColor: '#f6faf9' }}>
      <Container maxWidth="lg">
        <Typography component="h1" sx={{ mb: 4, color: '#163938', fontSize: { xs: '2rem', md: '3rem' }, fontWeight: 700 }}>
          {title}
        </Typography>
        <Grid container spacing={3}>
          {blogData.map((blog) => {
            const articleTitle = t(blog.title);
            const description = t(blog.description).replace(/<[^>]*>/g, '');
            return (
              <Grid item xs={12} key={blog.id}>
                <Card
                  component={Link}
                  to={'/blogg/' + slugify(articleTitle)}
                  aria-labelledby={'article-' + blog.id}
                  sx={{
                    display: 'flex', flexDirection: { xs: 'column', md: 'row' },
                    color: 'inherit', textDecoration: 'none', borderRadius: 3,
                    boxShadow: '0 6px 28px rgba(22,57,56,0.07)', overflow: 'hidden',
                    '&:hover': { color: 'inherit', boxShadow: '0 6px 28px rgba(22,57,56,0.15)' },
                    '&:focus-visible': { outline: '3px solid #794391', outlineOffset: 4 },
                  }}
                >
                  <CardMedia
                    component="img" image={blog.image} alt={articleTitle} loading="lazy"
                    sx={{ width: { xs: '100%', md: '42%' }, aspectRatio: '1500 / 785', objectFit: 'contain', flexShrink: 0, backgroundColor: '#fff' }}
                  />
                  <CardContent sx={{ p: { xs: 3, md: 4 }, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                    <Typography component="h2" id={'article-' + blog.id} sx={{ color: '#163938', fontSize: '1.4rem', lineHeight: 1.35, fontWeight: 700, mb: 2 }}>
                      {articleTitle}
                    </Typography>
                    <Typography component="p" sx={{ color: '#526565', lineHeight: 1.7, mb: 2 }}>{description}</Typography>
                    <Typography component="span" sx={{ color: '#146b65', fontWeight: 700 }}>
                      {isEnglish ? 'Read the article' : 'Läs artikeln'} <span aria-hidden="true">↗</span>
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            );
          })}
        </Grid>
      </Container>
    </Box>
  );
}
